import {StyleSheet} from 'react-native';

import {indent} from '/constant/layout.constant';
import {cloudLight, grayscale, white} from '/theme/color/on.color';
import {codGray} from '/theme/color/secondary.color';

const styles = StyleSheet.create({
  mainContainer: {
    padding: 0,
    marginHorizontal: indent * 0.8,
    marginTop: indent * 2.4,
    backgroundColor: white,
  },
  container: {
    width: '100%',
  },
  buttonContainer: {
    borderWidth: 1,
    borderColor: cloudLight,
    borderRadius: 8,
    justifyContent: 'center',
    alignItems: 'center',
    marginTop: indent * 0.4,
    height: indent * 2.65,
  },
  button: {
    flexDirection: 'row',
    flex: 1,
    alignItems: 'center',
  },

  buttonText: {
    color: codGray,
  },
  plusIcon: {
    marginLeft: indent * 0.4,
    fontSize: 16,
    color: grayscale,
  },
});

export default styles;
